



















































import { computed, defineComponent, ref } from '@vue/composition-api';
import { useGlobals } from '@/hooks/use-globals';
import { getViewStorePath } from '@/store/store.helpers';
import { name } from '@/views/rate-checker-configuration/rate-checker-table/rate-checker-table.route';
import cBreadcrumb from '@/components/breadcrumb/breadcrumb.component.vue';
import CFooterPanel from '@/components/footer-panel/footer-panel.component.vue';
import { TranslateResult } from 'vue-i18n';

export default defineComponent({
  name: 'vRateCheckerTable',
  components: {
    cBreadcrumb,
    CFooterPanel,
  },
  setup() {
    const { i18n, store } = useGlobals();
    const getBreadcrumbTranslation = computed((): TranslateResult => i18n.t(`${name}.meta.breadcrumb`));
    const tableData = computed((): string => store.state.views.vRateCheckerTable.tableData);
    const tableHeader = computed((): string => store.state.views.vRateCheckerTable.tableHeader);
    const getTranslation = (value: string): string => ref(i18n.t(`${name}.${value}`)).value.toString();

    store.dispatch(`${getViewStorePath(name)}/checkRateChecker`);
    store.dispatch(`${getViewStorePath(name)}/getDataOfTableRateChecker`);

    const MAX_INT = ref(2147483647);
    return {
      MAX_INT,
      tableData,
      tableHeader,
      getTranslation,
      getBreadcrumbTranslation,
    };
  },
});
